'use client';
import { usePathname } from 'next/navigation';
import { FC, ReactNode, Children } from 'react';

interface ClientLayoutWrapperProps {
    children: ReactNode;
}

const ClientLayoutWrapper: FC<ClientLayoutWrapperProps> = ({ children }) => {
    const pathName = usePathname();
    const isHideHeaderFooter = ['/deep', '/jainam', '/kaushal'].includes(pathName || '');

    const childrenArray = Children.toArray(children);
    
    return (
        <>
            {childrenArray.map((child, index) => {
                // Hide Header (first child) and Footer (fourth child) for specific paths
                if ((index === 0 || index === 3) && isHideHeaderFooter) {
                    return null;
                }
                return child;
            })}
        </>
    );
};

export default ClientLayoutWrapper;